/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useLabels } from '@/hooks/useLabels';
import { Actionable, Card, View, Text, Icon } from '@az/starc-ui';
import { ChevronRight } from '@az/starc-ui-icons';
import { ListMessageIcon } from '../../ListMessageIcon/ListMessageIcon';
import MobileBlogMenuNavigationStyles from '../MobileBlogMenuNavigation.module.scss';

const labelMap = {
  mobileMenuButton: 'label_BLOG_MobileMenuButton',
};

type MobileBlogMenuButtonProps = {
  handleOpenModal: () => void;
};

export const MobileBlogMenuButton = ({ handleOpenModal }: MobileBlogMenuButtonProps) => {
  const labels = useLabels(labelMap);

  return (
    <View className={MobileBlogMenuNavigationStyles.container}>
      <Actionable onClick={handleOpenModal} className={MobileBlogMenuNavigationStyles.button}>
        <Card hasHoverEffect={false}>
          <View direction="row" justify="space-between" align="center" padding={{ s: [3, 4] }}>
            <View
              direction="row"
              justify="start"
              align="center"
              className={MobileBlogMenuNavigationStyles.message}
            >
              <ListMessageIcon />
              <Text weight="regular" className={MobileBlogMenuNavigationStyles.messageText}>
                {labels.mobileMenuButton}
              </Text>
            </View>
            <View>
              <Icon size={4.5} svg={ChevronRight} />
            </View>
          </View>
        </Card>
      </Actionable>
    </View>
  );
};
